function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 0.500005C10 0.307802 9.88983 0.132613 9.71659 0.0493531C9.54336 -0.0339069 9.33774 -0.0104977 9.18765 0.10957L4.32461 4H0.5C0.223858 4 0 4.22386 0 4.5V10.5C0 10.7761 0.223858 11 0.5 11H4.32461L9.18765 14.8904C9.33774 15.0105 9.54336 15.0339 9.71659 14.9507C9.88983 14.8674 10 14.6922 10 14.5V0.500005ZM4.81235 4.89044L9 1.54032V13.4597L4.81235 10.1096C4.72369 10.0386 4.61354 10 4.5 10H1V5H4.5C4.61354 5 4.72369 4.96136 4.81235 4.89044Z",
  fill: "#BABABA"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3927 3.60653C13.1974 3.41124 12.8809 3.41119 12.6856 3.60642C12.4903 3.80165 12.4902 4.11824 12.6855 4.31353C13.5291 5.1574 14.003 6.30179 14.003 7.49503C14.003 8.68826 13.5291 9.83265 12.6855 10.6765C12.4902 10.8718 12.4903 11.1884 12.6856 11.3836C12.8809 11.5789 13.1974 11.5788 13.3927 11.3835C14.4238 10.3521 15.003 8.95343 15.003 7.49503C15.003 6.03662 14.4238 4.63793 13.3927 3.60653Z",
  fill: "#BABABA"
});

var SvgIconVolumeMid = function SvgIconVolumeMid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconVolumeMid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_volume_mid.0a66b7b5.svg";
export { ForwardRef as ReactComponent };